import React from "react";
import logo from "../../../assets/img/logo.svg";
import { Button, LoginPage as TablerLoginPage, Text, Card } from "tabler-react";
import {Link, useHistory} from 'react-router-dom';
import {Alerta} from "../../../utils/Alerta";
import {Formik} from "formik";
import {useAuth} from "../../../hooks/AuthContext";

export function DefaultLoginForm() {
  const history = useHistory();
  const { signIn, store } = useAuth();

  async function handleLogin(email?: string, password?: string) {
    try {
      await signIn({
        email: email,
        password: password,
      });

      if(!!store && !!store.id) {
        history.push('dashboard')
      }
    } catch (err) {
      Alerta("Login ou senha incorretos");
    }
  }

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}

      validate={values => {
        // same as above, but feel free to move this into a class method now.
        let errors: any = {};
        if (!values.email) {
          errors.email = "Obrigatório";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
          errors.email = "Endereço de e-mail inválido";
        }
        return errors;
      }}

      onSubmit={async (values) => {
        try {
          await handleLogin(values.email, values.password);
        } catch (err) {
          Alerta('Login ou senha incorretos');
        }
      }}

      render={({
         values,
         errors,
         touched,
         handleChange,
         handleBlur,
         handleSubmit,
         isSubmitting,
      }) => {
        return <>
            <TablerLoginPage
              onSubmit={handleSubmit}
              onChange={handleChange}
              onBlur={handleBlur}
              values={values}
              errors={errors}
              touched={touched}
              logoUrl={logo}
              strings={{
                title: "Login",
                buttonText: "Login",
                emailLabel: "E-Mail",
                emailPlaceholder: "E-Mail",
                passwordLabel: "Senha",
                passwordPlaceholder: "Senha",
              }}
            />
            <div className="text-center">
              <Link style={{fontSize: "14px"}} to="/forgot-password">
                Esqueceu sua senha?
              </Link>
            </div>
            <Button.List style={{justifyContent: "center", display: "flex"}}>
              <Button
                className="w-15"
                color="default"
                RootComponent="a"
                href="/login-monitor"
                style={{color: "blue", fontSize: "11px", fontWeight: "100"}}
              >
                Login interno Magazord
              </Button>
            </Button.List>
            <Card.Body
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
                marginTop: "50px",
              }}
            >
            </Card.Body>
          </>
      }}
    />
  )
}
